export const visaTypes = [
    "Tourist Visa",
    "Business Visa",
    "Student Visa",
    "Work Visa",
    "Transit Visa",
    "Immigrant Visa",
    "Spouse Visa",
    "Family Reunion Visa",
    "Medical Visa",
    "Cultural Exchange Visa",
    "Diplomatic Visa",
    "Journalist Visa",
    "Retirement Visa",
    "Religious Worker Visa",
    "Temporary Resident Visa",
    "Investor Visa",
    "Seasonal Worker Visa",
    "Au Pair Visa",
    "Permanent Resident Visa",
    "Fiancé(e) Visa",
    "Humanitarian Visa",
    "Refugee Visa",
    "Asylum Visa",
    "Special Purpose Visa",
    "Short-Term Work Visa",
    "Long-Term Work Visa",
    "Dependent Visa",
    "Research Visa",
    "Sports Visa",
    "Training Visa"
  ];
  